import { findOptions, getOptionAsObject } from "../../../helpers/StringHelper";

export const mapEvents = (data = [], options) => {
  const {
    typeOfEventOptions,
    provinceOptions,
    territoryOptions,
    associatedRiskOptions,
    typeOfDevelopmentChallengeOptions,
    riskCategoriesOptions = [],
    countryOptions = [],
  } = options || {};
  return (data || []).map(event => {
    const {
      typeOfEvent = '',
      eventDescription = '',
      dateOfEvent = '',
      administrativeLevel1 = '',
      administrativeLevel2 = '',
      loc_administrativeLevel1 = '',
      loc_administrativeLevel2 = '',
      associatedRisk = [],
      sdg = []
    } = event || {};
    const author = event.author ? `${event.author.firstName} ${event.author.lastName}` : '';
    let category = [];
    const subCategory = [];
    if (typeOfEvent) {
      if (['incident', 'riskMitigationMeasures'].includes(typeOfEvent) && associatedRisk && associatedRisk.length > 0) {
        const opt = getOptionAsObject(associatedRisk, associatedRiskOptions);
        const groups = [];
        (opt || []).forEach(o => {
          if (o.group && !groups.includes(o.group)) {
            groups.push(o.group);
          }
          subCategory.push(o.label);
        });
        category = findOptions(groups, riskCategoriesOptions);
      } else if (typeOfEvent === 'other' && sdg && sdg.length > 0) {
        category = findOptions(sdg, typeOfDevelopmentChallengeOptions);
      }

    }
    const level1 = administrativeLevel1 || loc_administrativeLevel1;
    const level2 = administrativeLevel2 || loc_administrativeLevel2;
    return {
      id: event.datastakeId ? event.datastakeId : '',
      typeOfEvent: event ? findOptions(typeOfEvent, typeOfEventOptions) : '',
      author,
      dateOfEvent: event ? dateOfEvent : '',
      eventTitle: event && event.eventTitle ? event.eventTitle : '',
      eventDescription: event ? eventDescription : '',
      location: event.locationName || '',
      country: event && event.country
        ? findOptions(event.country, countryOptions) : '',
      province: level1 ? findOptions(level1, provinceOptions) : '',
      territory: level2 ? findOptions(level2, territoryOptions) : '',
      category,
      associatedRisk: subCategory,
      version: event.version,
      dbId: event.id,
      pmeProject: event.pmeProject,
      updatedAt: event.updatedAt,
      publishedAt: event.publishedAt,
    };
  })
}

export const getEventFilterOptions = (options, view) => {
  const {
    associatedRiskOptions = [],
    countryOptions = [],
    riskCategoriesOptions = [],
    typeOfEventOptions = [],
    administrativeLevel1,
    administrativeLevel2,
  } = options || {};
  const _default = {
    associatedRisk: associatedRiskOptions,
    country: countryOptions,
    typeOfEvent: typeOfEventOptions,
    administrativeLevel1,
    administrativeLevel2,
  }

  if (['incidents', 'corrective-actions', 'testimonials'].includes(view)) {
    return {
      ..._default,
      category: riskCategoriesOptions.map((o) => {
        const { value } = o;
        const stringifiedValue = (options.associatedRiskOptions)
          .filter((v) => v.group === value)
          .map((v) => v.value)
          .join(',');

        return {
          label: o.label,
          value: stringifiedValue || value,
        };
      }),
    }
  }

  return _default;
}

export const filtersConfig = {
  eventTitle: '',
  datastakeId: '',
  // location: '',
  // author: '',
  // territory: '',
  // province: '',
};

export const selectFiltersConfig = {
  country: {
    type: 'select',
    label: 'Country',
    placeholder: (t) => `${t('Filter by')} ${t('Country').toLowerCase()}`,
    style: { flex: 1 },
    labelStyle: { flex: 1 },
    getLabel: (option) => option.label,
    getValue: (option) => option.value,
  },
  administrativeLevel1: {
    type: 'ajaxSelect',
    label: ({ t = (s) => s, options = {}, filters = {}, language = 'en' }) => {
      const { administrativeLevel1 } = options;

      if (administrativeLevel1) {
        if (options.country) {
          const _item = administrativeLevel1[filters.country];
          if (_item) {
            if (_item[language]) {
              return _item[language]
            }
          }
        }
      }

      return t('Province');
    },
    placeholder: (t) => `${t('Filter by')} ${t('Province').toLowerCase()}`,
    filters: (data) => ({
      country: data.country,
      level: 'level_1',
    }),
    show: (data) => !!!data.country,
    disabled: (data) => !!!data.country,
    mapper: { label: "name", value: "id" },
    method: 'getOptions',
    entity: 'AdministrativeLevel',
    style: { flex: 1 },
    labelStyle: { flex: 1 },
  },
  administrativeLevel2: {
    type: 'ajaxSelect',
    label: ({ t = (s) => s, options = {}, filters = {}, language = 'en' }) => {
      const { administrativeLevel2 } = options;

      if (administrativeLevel2) {
        if (options.country) {
          const _item = administrativeLevel2[filters.country];
          if (_item) {
            if (_item[language]) {
              return _item[language]
            }
          }
        }
      }

      return t('Province');
    },
    placeholder: (t) => `${t('Filter by')} ${t('Territory').toLowerCase()}`,
    filters: (data) => ({
      country: data.country,
      level: 'level_2',
      administrativeLevel1: data.administrativeLevel1,
    }),
    disabled: (data) => !(data.country && data.administrativeLevel1),
    show: (data) => !(data.country && data.administrativeLevel1),
    mapper: { label: "name", value: "id" },
    method: 'getOptions',
    entity: 'AdministrativeLevel',
    style: { flex: 1 },
    labelStyle: { flex: 1 },
  },
  typeOfEvent: {
    type: 'select',
    label: 'Type of event',
    placeholder: (t) => `${t('Filter by')} ${t('Type of event').toLowerCase()}`,
    style: { flex: 1 },
    labelStyle: { flex: 1 },
    getLabel: (option) => option.label,
    getValue: (option) => option.value,
  },
  category: {
    type: 'select',
    label: 'Category',
    placeholder: (t) => `${t('Filter by')} ${t('Category').toLowerCase()}`,
    style: { flex: 1 },
    labelStyle: { flex: 1 },
    getLabel: (option) => option.label,
    getValue: (option) => option.value,
  },
  timeframe: {
    type: 'timeframe',
    label: 'Timeframe',
    style: { flex: 1 },
  },
  /*
  category: {
    type: 'select',
    label: 'Category',
    placeholder: 'Filter by category of event',
    style: { width: 200 },
    getLabel: (option) => option.label,
    getValue: (option) => option.value,
  },
  // TO-DO add associated Risk
  associatedRisk: {
    type: 'select',
    label: 'Associated Risk',
    placeholder: 'Filter by associated risk of event',
    style: { width: 200 },
    getLabel: (option) => option.label,
    getValue: (option) => option.value,
  },
  */
};

export const checkboxConfig = {
  eventTitle: 'Name',
  datastakeId: 'ID',
  // location: 'Location',
  // author: 'Author',
  // territory: 'Territory',
  // province: 'Province',
};

export const allStatuses = ['incident', 'riskMitigationMeasures', 'other'];

export const eventsView = 'events';
